import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MainComponentWrapper from "../../Components/Common/MainComponentWrapper";
import MainPagination from "../../Components/Common/MainPagination";
import Event from "../../Components/EventMgt/Event";
import CustomLayoutUser from "../../Components/Layout/CustomLayoutUser";
import useHttpHook from "../../Hooks/HttpHook";
import {
  getOrganizerEventsByUsername,
} from "../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../utils/Helper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/notify";
export function UserProfile() {
  const [events, setEvents] = useState();
  const [loading, sendRequest, error] = useHttpHook();
  const [eventsList, setEventsList] = useState();
  const { userName } = useParams();

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const getEvents = useCallback(
    async (page = 1) => {
      if (!userName) return;
      let events = await sendRequest(
        `${getOrganizerEventsByUsername}/${userName}?page=${page}`,
        {
          method: "get",
        }
      );
      if (page == 1) {
        setEventsList(events);
      } else {
        setEventsList((prevState) => {
          return createObjectForPaginatedResult(events, prevState);
        });
      }
    },
    [sendRequest, userName]
  );

  useEffect(() => {
    setEventsList(undefined);
    getEvents();
  }, [getEvents]);

  return (
    <CustomLayoutUser
      Heading="Events"
      TitleMark={true}
      TitleMarkClassName="event-my-events-title-mark"
      TitleClassName="event-my-events-title"
      HeadClassName="event-my-events-head"
      ExtraclassName="event-my-events-panel"
    >
      <MainComponentWrapper Loading={loading} errorInfo={error}>
        {eventsList?.data?.itemsList?.length > 0 ? (
            <MainPagination getEventsMethod={getEvents} MainData={eventsList}>
              <div className="event-created-grid" role="list" aria-label="Organizer events">
                {eventsList?.data?.itemsList?.map(
                  ({
                    _id,
                    title,
                    eventTiming,
                    description,
                    mainimage,
                    isActive,
                    category,
                  }) => (
                    <Event
                      key={_id}
                      title={title}
                      eventTiming={eventTiming}
                      Id={_id}
                      description={description}
                      mainimage={mainimage}
                      getEvents={getEvents}
                      category={category}
                      isActive={isActive}
                    />
                  )
                )}
              </div>
            </MainPagination>
          ) : (
            <div className="event-empty">
              <i className="bi bi-calendar-x" aria-hidden="true"></i>
              <p>No events found</p>
            </div>
          )}
      </MainComponentWrapper>
    </CustomLayoutUser>
  );
}
